import React from 'react';
import { Card, Modal, Space, Typography } from 'antd';
import { CopyOutlined, FileAddOutlined } from '@ant-design/icons';
import { useI18n } from '../i18n';
import { brandSemantic } from '../config/brand';

const { Text } = Typography;

export default function ProductCreateChooserModal({
  open,
  onCancel,
  onCreateNew,
  onCopyExisting,
  hideCopyOption = false,
}) {
  const { t } = useI18n();

  return (
    <Modal
      title={t('Add Product')}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={520}
      destroyOnClose
    >
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        <Card
          hoverable
          onClick={() => onCreateNew('Standard')}
          styles={{ body: { padding: 16 } }}
        >
          <Space align="start">
            <FileAddOutlined style={{ fontSize: 22, color: brandSemantic.primary, marginTop: 2 }} />
            <div>
              <Text strong>{t('New Standard Product')}</Text>
              <div style={{ color: brandSemantic.textSecondary, fontSize: 13 }}>
                {t('One supplier, one supplier item number, one colour.')}
              </div>
            </div>
          </Space>
        </Card>
        <Card
          hoverable
          onClick={() => onCreateNew('Custom')}
          styles={{ body: { padding: 16 } }}
        >
          <Space align="start">
            <FileAddOutlined style={{ fontSize: 22, color: brandSemantic.primary, marginTop: 2 }} />
            <div>
              <Text strong>{t('New Custom Product')}</Text>
              <div style={{ color: brandSemantic.textSecondary, fontSize: 13 }}>
                {t('A one-off production made for a specific customer.')}
              </div>
            </div>
          </Space>
        </Card>
        {!hideCopyOption && (
          <Card
            hoverable
            onClick={onCopyExisting}
            styles={{ body: { padding: 16 } }}
          >
            <Space align="start">
              <CopyOutlined style={{ fontSize: 22, color: brandSemantic.primary, marginTop: 2 }} />
              <div>
                <Text strong>{t('Copy Existing Product')}</Text>
                <div style={{ color: brandSemantic.textSecondary, fontSize: 13 }}>
                  {t('Start from an existing product — for a colour variation or a repeat custom job.')}
                </div>
              </div>
            </Space>
          </Card>
        )}
      </Space>
    </Modal>
  );
}
